import { render, staticRenderFns } from "./UserDetailsView.vue?vue&type=template&id=46a109f2&scoped=true&"
import script from "./UserDetailsView.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsView.vue?vue&type=style&index=0&id=46a109f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a109f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a109f2')) {
      api.createRecord('46a109f2', component.options)
    } else {
      api.reload('46a109f2', component.options)
    }
    module.hot.accept("./UserDetailsView.vue?vue&type=template&id=46a109f2&scoped=true&", function () {
      api.rerender('46a109f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserDetailsView.vue"
export default component.exports